import { render, staticRenderFns } from "./NewCostHistory.vue?vue&type=template&id=750e886b&scoped=true&"
import script from "./NewCostHistory.vue?vue&type=script&lang=js&"
export * from "./NewCostHistory.vue?vue&type=script&lang=js&"
import style0 from "./NewCostHistory.vue?vue&type=style&index=0&id=750e886b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750e886b",
  null
  
)

export default component.exports